import React, { Component } from 'react';
import {injectIntl} from 'react-intl';
import { withRouter } from 'react-router-dom';

import LoadingIndicator from 'components/ui/loading/LoadingIndicator';
import MessagePanel from 'components/ui/layout/panel/MessagePanel';
import {getQueryParams, setQueryParams} from 'util/router';


import 'style/util/async-component.scss';

const QUERY_PARAM_REFRESH_CHUNKS = 'refresh_chunk';
const REFRESH = 1;


export default importComponent => {
    class AsyncComponent extends Component {
        constructor(props) {
            super(props);

            this.state = {
                component: null
            };
        }

        async componentDidMount() {
            const {history:{location}} = this.props;

            try {
                const { default: component } = await importComponent();

                this.setState({
                    component
                });
            } catch (e) {
                const query = getQueryParams(location.search);

                if (query[QUERY_PARAM_REFRESH_CHUNKS]) {
                    console.error(e);
                    this.setState({
                        error: e
                    });
                } else {
                    setQueryParams(this.props, QUERY_PARAM_REFRESH_CHUNKS, REFRESH);
                    //window.location.reload();
                }
            }
        }

        render() {
            const C = this.state.component;
            const {error} = this.state;
            const {intl:{formatMessage}} = this.props;

            const message = formatMessage({id: 'error.chunk.text'});

            if (error) {
                return (
                    <MessagePanel
                        title={formatMessage({id: 'error.chunk.title'})}
                        message={message}
                    />
                );
            }

            return C ? <C {...this.props} /> : <LoadingIndicator />;
        }
    }

    return injectIntl(withRouter(AsyncComponent));
};



// WEBPACK FOOTER //
// ./src/util/AsyncComponent.js